"use strict";
var baseGetTag = require('./_baseGetTag'), isObjectLike = require('./isObjectLike');
var argsTag = '[object Arguments]';
function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;
//# sourceMappingURL=_baseIsArguments.js.map